<template>
  <three-step-history
    api="home-status-request"
    :columns="columns"
    done-word="ປ່ຽນແລ້ວ"
  />
</template>

<script>
import ThreeStepHistory from '@/views/threeStep/ThreeStepHistory.vue';

export default {
  name: 'HomeStatusHistory',
  components: { ThreeStepHistory },
  title() {
    return 'Vientiane Waste Co-Dev|Home Status History';
  },
  data() {
    return {
      columns: [
        { text: 'ລູກຄ້າ', value: 'customer_name' },
        { text: 'ແພັກເກດ', value: 'package' },
        { text: 'ປ່ຽນຈາກ → ເປັນ', value: 'to_status', sortable: false },
      ],
    };
  },
};
</script>
